import axios from 'axios';
import { apiConfig } from '@/core/config/js/index.js';

// eslint-disable-next-line import/prefer-default-export
export const apiInstance = axios.create({
  baseURL: apiConfig.baseUrl,
  timeout: 8000,
});
